<div class="wrapper ">
	<cv-tab-group>
		<cv-tab [active]="true" [title]="'AppScope'">
			<div *ngIf="orderInfo; else emptyData">
				<diV class="inline-content">
					<div *ngFor="let log of orderInfo; let even = even" class="inline-info">
						<div class="card-detail" [ngClass]="{ backgrd: even }">
							<label class="data-field">{{ log.name }} :</label>
							<label class="data-value"> {{ log.value ? log.value : 'N/A' }}</label>
						</div>
					</div>
					<div class="inline-info">
						<div class="card-detail">
							<label class="data-field">Creation UserName: </label>
							<label class="data-value"> {{ creationUserName ? creationUserName: 'N/A' }}</label>
						</div>
					</div>
				</diV>
				<cv-collapse>
					<cv-panel [class]="'dark'" [isExpandable]="false" [rightButtons]="copyAppScopeMsgRequest">
						<ace-editor
							#markupEditor
							[(text)]="appScopeMsgRequest"
							[mode]="'json'"
							[ngStyle]="{
								height: '400px',
								width: '100%'
							}"
						>
						</ace-editor>
					</cv-panel>
				</cv-collapse>

				<div class="action-re-queue" *ngIf="
					(data.appScope.asyncResponse &&
					data.appScope.asyncResponse.messageRequest &&
					data.appScope.asyncResponse.status === 'FAILED') || inProcessRequeueAppScope">
					<button class="btn-primary btn btn-sm" (click)="reEnqueueConfirmationOrder('appScope')">
						Requeue
						<i class="fad fa-forward"></i>
					</button>
				</div>
			</div>
		</cv-tab>
		<cv-tab [title]="acuityInstance">
			<div *ngIf="orderAcuityInfo; else emptyData">
				<diV class="inline-content">
					<div *ngFor="let log of orderAcuityInfo; let even = even" class="inline-info">
						<div class="card-detail" [ngClass]="{ backgrd: even }">
							<label class="data-field">{{ log.name }} :</label>
							<label class="data-value"> {{ log.value ? log.value : 'N/A' }}</label>
						</div>
					</div>
				</diV>
				<cv-collapse>
					<cv-panel [class]="'dark'" [isExpandable]="false" [rightButtons]="copyAcuityMsgRequest">
						<ace-editor
							#markupEditor2
							[(text)]="acuityMsgRequest"
							[mode]="'json'"
							[ngStyle]="{
								height: '400px',
								width: '100%'
							}"
						>
						</ace-editor>
					</cv-panel>
				</cv-collapse>
				<div class="action-re-queue" *ngIf="
					(data.acuity.asyncResponse &&
					data.acuity.asyncResponse.messageRequest &&
					data.acuity.asyncResponse.status === 'FAILED')
					|| inProcessRequeueAcuity">
					<button class="btn-primary btn btn-sm" (click)="reEnqueueConfirmationOrder(data.acuity?.instance)">
						Requeue
						<i class="fad fa-forward"></i>
					</button>
				</div>
			</div>
		</cv-tab>
	</cv-tab-group>
</div>
<ng-template #emptyData>
	<div class="empty-selection__content">
		<label class="empty-selection__icon"><i class="fas fa-file"></i></label>
		<label class="empty-selection-instruction__lbl"
			>It seems that this order does not have any info related</label
		>
	</div>
</ng-template>
